const competerRoutes = [
  {
    path: '',
    component: () => import('@/app/shared/layouts/main/Main.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/competer/dashboard',
        name: 'competerDashboard',
        component: () => import('./views/Dashboard.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'price-eye', url: '/competer/dashboard' },
            { title: 'dashboard', active: true },
          ],
          pageTitle: 'Dashboard',
          rule: 'editor'
        }
      },
      {
        path: '/competer/alerts',
        name: 'competerAlerts',
        component: () => import('./views/Alerts.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'price-eye', url: '/competer/dashboard' },
            { title: 'alerts', active: true },
          ],
          pageTitle: 'Alerts',
          rule: 'editor'
        }
      },
      {
        path: '/orbit/competer',
        name: 'orbitCompeter',
        component: () => import('./views/Competer.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'orbit' },
            { title: 'price-eye', active: true },
          ],
          pageTitle: 'PriceEye',
          rule: 'editor'
        }
      },
      {
        path: '/competer/sku/:id',
        name: 'sku',
        component: () => import('./views/Sku.vue'),
        meta: {
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: 'price-eye', url: '/competer/dashboard' },
                { title: 'stock', url: '/competer/stock' },
                { title: 'sku', active: true },
            ],
            pageTitle: 'SKU',
            rule: 'editor'
        }
      },
      {
        path: '/competer/stock/:view?',
        name: 'stock',
        component: () => import('./views/Stock.vue'),
        meta: {
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: 'price-eye', url: '/competer/dashboard' },
                { title: 'stock', active: true },
            ],
            pageTitle: 'Stock',
            rule: 'editor'
        }
      },
      {
        path: '/competer/explore',
        name: 'competerExplore',
        component: () => import('./views/Analyze.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'price-eye' },
            { title: 'explore', active: true },
          ],
          pageTitle: 'Insights',
          rule: 'editor'
        }
      },
      {
        path: '/competer/discover',
        name: 'competerDiscover',
        component: () => import('./views/Discover.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'price-eye' },
            { title: 'discover', active: true },
          ],
          pageTitle: 'Discover',
          rule: 'editor'
        }
      }          
    ]
  }
];

export default competerRoutes;
